import React, { Component ,useRef, createRef} from 'react'
import axios from 'axios';
import MyLoader from '../Spinner/MyLoader';
import SessionManager from '../Utils/SessionManager';
import {BrowserRouter as Router,Link, Redirect, Route } from 'react-router-dom'
import '../css/Admin_css/admin-customize.css';
import COLORS from '../resources/colors/COLORS';
import SpecialCaseCreation from './SpecialCaseCreation';
import myToast from '../Utils/MyToast';
import SelectClass from '../ChildComponent/SelectClass';
export default class SpecialCaseStudent extends Component {
  constructor(props) {
    super(props)        
   
    const token=localStorage.getItem("token");
    let loggedIn=true;
    if(token==null){
      loggedIn=false;
    }
  
    this.state={  
        isOpen: false, 
        loggedIn:true,
        Loading:false,
        LoadingStudent:false,
        mSpecialCaseStudent:[],
        CLASS_ID:'',
        SECTION_ID:'',
        SESSION_ID:'',
        SESSION_NAME:'',
        SELECTED_CLASS_POSITION:0,
        
    }
    this.CallBackClassSelect= this.CallBackClassSelect.bind(this);
     
  }

  CallBackClassSelect = (class_id,section_id,session_id,selected_position,class_name,section_name,session_name) => {
  
    this.state.CLASS_ID=class_id;
    this.state.SECTION_ID=section_id;
    this.state.SESSION_ID=session_id;
    this.state.SELECTED_CLASS_POSITION=selected_position;
    //alert("Back"+class_id+"/"+section_id+"/"+session_id);
    this.getSpecialCaseStudent();
  }
  componentDidMount() {
  //  window.scrollTo(0, 0)
     
  }     
  getSpecialCaseStudent(){
  
  this.state.mSpecialCaseStudent=[];
    
    this.setState({
      LoadingStudent:true
    })
    
    const SCHOOL_CODE=SessionManager.getSchoolCode();
    const FUNCTION_NAME='getSpecialCaseStudents.php'
    URL=process.env.REACT_APP_SERVER_NAME+process.env.REACT_APP_TARGET_DIR+FUNCTION_NAME
    
   axios.get(URL,{
  params:{
   
    session_id:this.state.SESSION_ID,
    class_id:this.state.CLASS_ID,
    section_id:this.state.SECTION_ID,
    school_code:SCHOOL_CODE,
  }
}).then(res => res.data)
.then((response) => {
 
  this.setState({ 
    LoadingStudent:false
   })
    //console.log("Response2>>>>>"+response);
    let api_status=response.api_status;
    //alert(api_status);  
    if(api_status=="OK")
    {
      this.setState({            
        mSpecialCaseStudent:response.data,
      })
           
    }
    else{
      let api_remark=response.api_remark;
      myToast.notify_warning(api_remark);
    }
 }).catch((error)=>{
  this.setState({ 
    Loading:false
   })
  console.log("error>>>>>"+error);
  });
}

  render() {
    if(this.state.loggedIn==false)
    {
    return <Redirect to='/Login'/>;
    }
    if(this.state.Loading)
    {
         return <MyLoader/>
    }
    else{       
     
        return (
          
        <Router>
        <switch>
          <Route path={'/AdminMain/SpecialCaseStudent'}  exact render={
            ()=>{
          return(  
              <div className="content" style={{background:COLORS.white}}>
          <div className="content-header" >
            <div className="leftside-content-header">
              <ul className="breadcrumbs">
                <li><i className="fa fa-home text-white" aria-hidden="true" /><a href="#"> Special Case Student </a></li>
              </ul>
            </div>
          </div>
          <div className="bg_page_grey_rounded box_shadow " style={{'--mMargin':'100px'}}>


          {this.state.Loading ? <MyLoader/> : 
         <div>
           
          <SelectClass action={this.CallBackClassSelect} selected_position='0'></SelectClass>

          {this.state.LoadingStudent?<MyLoader/>:
            <div className="row gravity_center" style={{padding:'5px 10px 5px 10px'}}> 
            {this.state.mSpecialCaseStudent && this.state.mSpecialCaseStudent.map((item, index) => { 
                var mFeeDetails=[];
                mFeeDetails=item.fee_details;
                                           
                return(       
                <div className="col-sm-12 col-md-12 "style={{padding:0}}>
                
                 <div className="bg_card_blue_outline" style={{margin:'5px 8px 10px 8px'}}>
                  <div className="row margin_0"> 
                  <div className="col-sm-2  bg_card_blue" style={{padding:'0px',height:'60px'}}>
                                <div className="gravity_center" style={{padding:'0px',margin:'2px',height:'50px',width:'50px'}}>
                                  <div className="circular_image">
                                      <img  src={item.student_img_path}  alt=""></img>
                                      <p className="student_id gravity_center"> <small> {item.student_enrollment_no} </small></p>
                                  </div> 
                                  </div>                
                                </div>
                                <div className="col-sm-8" style={{padding:'2px',height:'60px'}}>
                                  <h6 className="mb-0 black"> {item.stu_name} </h6>
                                  <p className="mb-0 black7"> Father: <span className='nowrap'>{item.father_name}</span> </p>
                                  <div className='gravity_center_row'>
                                      <h6 className="black7"><span> {item.class[0].section_id==='No'?'Class '+item.class[0].class_name:'Class '+item.class[0].class_name+':'+item.class[0].section_name} </span>  </h6>
                                      <p className="mb-0 black7" style={{fontSize:'10px'}}> SRN: <span>{item.sr_admission_no}</span> </p>
                                  
                                  </div>
                                 
                                
                                </div>
                                <div className="col-sm-2 padding_0 gravity_center"style={{height:'60px'}} >
                                  <div className="text-center bg_card_blue_outline width_fill_parent" style={{margin:'2px'}}>
                                    <p className="mb-0 black7"> Roll No. </p>
                                    <p> <div className="bg_circle_fill_primery_grey_outline gravity_center" style={{width:'25px', height:'26px',border:'2px',
                                    margin:'3px auto',fontSize:'20px',color:COLORS.white}}>{item.class[0].student_roll_no}</div> </p>
                                   
                                  </div>
                                </div>
                 </div>
                 <div className="row margin_0" style={{background:COLORS.green_dark}}>
                          <div className="col-sm-4 col-md-4 gravity_center txt_white">
                              <p>Applicable Fee</p>
                          </div>
                          <div className="col-sm-4 col-md-4 gravity_center txt_white">
                             <p>Class Fee</p>
                          </div>
                          <div className="col-sm-4 col-md-4 gravity_center txt_white">
                          <p>Special Fee</p>
                          </div>
                  </div>
                
                 {mFeeDetails && mFeeDetails.map((item2, index2) => { 
                                           
                     return( 
                      <div className="row margin_0">
                          <div className="col-sm-4 col-md-4 gravity_center">
                              <p>{item2.fee_name}</p>
                          </div>
                          <div className="col-sm-4 col-md-4 gravity_center">
                            <p>{item2.fee_value}</p>
                          </div>
                          <div className="col-sm-4 col-md-4 gravity_center">
                          <p>{item2.special_value}</p>
                          </div>
                       </div>
             
                        )
                    })}    
                  
                </div>
               
                </div>                   
                )
            })} 
            </div>  
            }
              </div>
           }


            <div className="row" style={{padding:'5px 10px 5px 10px'}}>
              <Link to="/AdminMain/SpecialCaseCreation" style={{width:'100%'}}>
                    <button className="btn btn-success"  style={{fontSize:'20px', margin:'3px 2px 5px 2px',width:'100%',height:'40px',background:COLORS.primary_color_shade5}}> Create Special Case</button>
               </Link>   
              </div>        
             </div>
           </div>
             )
            }
          } />
      
                       
          <Route path='/AdminMain/SpecialCaseCreation'  component={SpecialCaseCreation} />                    
          </switch>       
         </Router>  
          )
      }
    } 
  }
